import { useAuth } from "../../context/auth.context";

const statusEnum = {
  pending: "PENDING",
  active: "ACTIVE",
};

const ENDPOINT_URL = new URL("/api/treeIdUsers", process.env.REACT_APP_MAIN_API_ENDPOINT).href;

const UserService = {
  getImageUrl: async (imageId, isTargetImage, segmented) => {
    const data = {
      imageType: isTargetImage ? "treePart" : "search",
      imageId: imageId,
      segmented: segmented,
    };
    const data_string = JSON.stringify(data);
    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("userId");
    const response = await fetch(
      `${process.env.REACT_APP_MAIN_API_ENDPOINT}/api/treeIdUsers/${userId}/imageUrl?access_token=${token}`,
      {
        method: "POST",
        body: data_string,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );

    const fetced_data = await response.json();
    if (response.ok) {
      return fetced_data.url;
    } else {
      throw new Error(await response.text());
    }
  },

  getUsers: async function () {
    const response = await fetch(ENDPOINT_URL + '?filter={"include":["roles"]}', {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: sessionStorage.getItem("token"),
        Accept: "application/json",
      },
    });

    if (response.ok) {
      return await response.json();
    } else throw new Error(await response.text());
  },
  getUser: async function (id) {
    const response = await fetch(ENDPOINT_URL + `?filter={"include":["roles"],"where":{"id":"${id}"}}`, {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: sessionStorage.getItem("token"),
        Accept: "application/json",
      },
    });

    if (response.ok) {
      return await response.json();
    } else throw new Error(await response.text());
  },
  updateUser: async function (data) {
    const response = await fetch(ENDPOINT_URL, {
      method: "PATCH",
      mode: "cors",
      headers: {
        Authorization: sessionStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return await response.text();
    } else throw new Error(await response.text());
  },
  getRoles: async function () {
    const rolepath = ENDPOINT_URL.replace("treeIdUsers", "treeIdRoles");
    const response = await fetch(rolepath, {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: sessionStorage.getItem("token"),
        Accept: "application/json",
      },
    });

    if (response.ok) {
      return await response.json();
    } else throw new Error(await response.text());
  },
  addRole: async function (userid, roleid) {
    const rolepath = ENDPOINT_URL.replace("treeIdUsers", "/treeIdRoleMappings");
    const data = {
      principalType: "USER",
      principalId: userid,
      roleId: roleid,
    };

    const response = await fetch(rolepath, {
      method: "POST",
      mode: "cors",
      headers: {
        Authorization: sessionStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return await response.text();
    } else throw new Error(await response.text());
  },
  removeRole: async function (userid, roleid) {
    const response = await fetch(ENDPOINT_URL + `/${userid}/roles/rel/${roleid}`, {
      method: "DELETE",
      mode: "cors",
      headers: {
        Authorization: sessionStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (response.ok) {
      return await response.text();
    } else throw new Error(await response.text());
  },
  updateUserStatus: async function (user, token) {
    const jsonData = {
      activated: user.activated,
      id: user.id,
    };

    const response = await fetch(ENDPOINT_URL, {
      method: "PATCH",
      mode: "cors",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(jsonData),
    });

    if (response.ok) {
      return await response.text();
    } else throw new Error(await response.text());
  },
  updateUserPaid: async function (user, token) {
    // console.log(user);
    const jsonData = {
      paid: user.paid,
      id: user.id,
    };

    const response = await fetch(ENDPOINT_URL, {
      method: "PATCH",
      mode: "cors",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(jsonData),
    });

    if (response.ok) {
      return await response.text();
    } else throw new Error(await response.text());
  },
  loginUser: async function (email, password) {
    const formdata = createURLEncoded({
      email: email,
      password: password,
    });

    try {
      const res = await fetch(`${ENDPOINT_URL}/userLogin`, {
        method: "post",
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formdata,
      });

      const jsonResponse = await res.json();
      // console.log('jsonResponse', jsonResponse);

      if (jsonResponse.error) {
        console.log("error", jsonResponse.error);
        throw new Error(jsonResponse.error);
      } else {
        if (jsonResponse.authentication.success === true) {
          return {
            token: jsonResponse.authentication.result.token.id,
            userId: jsonResponse.authentication.result.user.id,
            roles: jsonResponse.authentication.result.roles,
          };
        } else {
          throw new Error(
            "Authentification failed" +
              (jsonResponse.authentication &&
                jsonResponse.authentication.result &&
                jsonResponse.authentication.result.roles &&
                (jsonResponse.authentication && jsonResponse.authentication.success === false
                  ? " : " + jsonResponse.authentication.errorMessage
                  : "")),
          );
        }
      }
    } catch (err) {
      console.log("error", err);
      throw new Error(err);
    }
  },
  logout: function () {
    sessionStorage.removeItem("token");
    fetch(ENDPOINT_URL + "/logout", {
      headers: {
        Authorization: sessionStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      mode: "cors",
      method: "post",
    })
      .then((res) => {
        if (res && res.ok === true) {
          console.log("logout ok");
        }
      })
      .catch((err) => {
        console.log("error", err);
        this.app.handleSnackbarOpen(err, this.app.snackbarClassNames.ERROR);
      });
  },
  reset: async function (email) {
    try {
      const res = await fetch(`${ENDPOINT_URL}/reset`, {
        method: "post",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email: email }),
      });

      const jsonResponse = await res.json();

      if (jsonResponse.error) {
        console.log("error", jsonResponse.error);
        throw new Error(jsonResponse.error);
      } else {
        if (jsonResponse.message.success === true) {
          return jsonResponse.message.message;
        } else {
          throw new Error("Reset failed" + (jsonResponse.message ? " : " + jsonResponse.message.errorMessage : ""));
        }
      }
    } catch (err) {
      console.log("error", err);
      throw new Error(err);
    }
  },
  resetPassword: async function (userId, token, newPassword) {
    try {
      const res = await fetch(`${ENDPOINT_URL}/changePasswordFromReset/${userId}`, {
        method: "post",
        mode: "cors",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ newPassword: newPassword }),
      });

      const jsonResponse = await res.json();

      if (jsonResponse.error) {
        console.log("error", jsonResponse.error);
        throw new Error(jsonResponse.error);
      } else {
        if (jsonResponse.message.success === true) {
          return jsonResponse.message.message;
        } else {
          throw new Error("Reset failed" + (jsonResponse.message ? " : " + jsonResponse.message.errorMessage : ""));
        }
      }
    } catch (err) {
      console.log("error", err);
      throw new Error(err);
    }
  },
  markMatchResult: async (searchId, reviewResult) => {
    const data = {
      searchId: searchId,
      reviewResult: reviewResult,
    };
    const data_string = JSON.stringify(data);
    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("userId");
    const response = await fetch(
      `${process.env.REACT_APP_MAIN_API_ENDPOINT}/api/treeIdUsers/${userId}/markMatchResult?access_token=${token}`,
      {
        method: "PATCH",
        body: data_string,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );

    const fetced_data = await response.json();
    if (response.ok) {
      return fetced_data;
    } else {
      console.log(fetced_data);
      throw new Error(fetced_data ? JSON.stringify(fetced_data) : await response.text());
    }
  },
  markActualImageQuality: async (id, actualImageQuality, type) => {
    const data = {
      id: id,
      actualImageQuality: actualImageQuality,
      type: type,
    };
    const data_string = JSON.stringify(data);
    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("userId");
    const response = await fetch(
      `${process.env.REACT_APP_MAIN_API_ENDPOINT}/api/treeIdUsers/${userId}/markActualImageQuality?access_token=${token}`,
      {
        method: "PATCH",
        body: data_string,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );

    const fetced_data = await response.json();
    if (response.ok) {
      return fetced_data;
    } else {
      throw new Error(fetced_data ? JSON.stringify(fetced_data) : await response.text());
    }
  },
  getTopMatches: async (queryLogId, n) => {
    const data = {
      searchId: queryLogId,
      n: n,
    };
    const data_string = JSON.stringify(data);
    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("userId");
    const response = await fetch(
      `${process.env.REACT_APP_MAIN_API_ENDPOINT}/api/treeIdUsers/${userId}/getTopNMatches?access_token=${token}`,
      {
        method: "POST",
        body: data_string,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );

    const fetced_data = await response.json();
    if (response.ok) {
      return fetced_data.data;
    } else {
      throw new Error(fetced_data ? JSON.stringify(fetced_data) : await response.text());
    }
  },
  setManuallyMatchedTargetId: async (searchId, manuallyMatchedTargetId) => {
    const data = {
      searchId: searchId,
      manuallyMatchedTargetId: manuallyMatchedTargetId,
    };
    const data_string = JSON.stringify(data);
    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("userId");
    const response = await fetch(
      `${process.env.REACT_APP_MAIN_API_ENDPOINT}/api/treeIdUsers/${userId}/setManuallyMatchedTargetId?access_token=${token}`,
      {
        method: "PATCH",
        body: data_string,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );

    const fetced_data = await response.json();
    if (response.ok) {
      return fetced_data;
    } else {
      console.log(fetced_data);
      throw new Error(fetced_data ? JSON.stringify(fetced_data) : await response.text());
    }
  },

  statusEnum: statusEnum,
};

export default UserService;

function createURLEncoded(details) {
  // console.log(MAIN_API_ENDPOINT)
  let formBody = [];
  for (const property in details) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  return formBody;
}
